import { Col } from 'antd';

const GridDatosGenerales = ({ description, builder, construction, concept, dateContract }) => {
    return (
        <>
            <Col xs={24} md={12}>
                <table style={{ width: "100%", borderSpacing: "0 6px" }}>
                    <tbody>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Descripción obra:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            { description }
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Contratista:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            SMB PROYECTOS
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Subcontratista:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            {builder}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>
            <Col xs={24} md={12}>
                <table style={{ width: "100%", borderSpacing: "0 6px" }}>
                    <tbody>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Obra (nombre):
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            { construction }
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Cliente:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            {concept}
                            </td>
                        </tr>
                        <tr>
                            <td style={{ color: "#98989A", fontWeight: 600, width: "200px" }}>
                            Fecha contrato:
                            </td>
                            <td style={{ textAlign: "right", fontWeight: 600, width: "120px" }}>
                            {dateContract}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </Col>
        </>
    )
}

export default GridDatosGenerales;